'use strict';

function initBootstrapTooltip() {
    $('[data-toggle="tooltip"]')
        .tooltip({
            trigger: 'manual',
            delay: { show: 100 }
        })
        .each(function () {
            var $element = $(this);
            // Store tooltip state for consistent screen reader behavior
            $element.data('tooltip-visible', false);
            $element.data('tooltip-hover', false);
            $element.attr('aria-expanded', 'false');

            // Generate unique ID for tooltip if not already present
            var tooltipId = $element.attr('id') || 'tooltip-' + Math.random().toString(36).substr(2, 9);
            if (!$element.attr('id')) {
                $element.attr('id', tooltipId);
            }
        });

    $(document)
        .on('mouseover', '[data-toggle="tooltip"]', function () {
            // Keep tooltip open when hovering over it
            var $tooltip = $(this);
            $tooltip.data('tooltip-hover', true);
        })
        .on('mouseleave', '[data-toggle="tooltip"]', function () {
            var $tooltip = $(this);
            $tooltip.data('tooltip-hover', false);
        })
        .on('mouseover', '[data-toggle="tooltip"]', function (e) {
            // Only show on hover if not triggered by keyboard/click
            if (e.originalEvent && e.originalEvent.type === 'mouseover') {
                var $tooltip = $(this);
                $tooltip.tooltip('show');
                $tooltip.data('tooltip-visible', true);
                if (!$tooltip.data('no-aria-expanded')) {
                    $tooltip.attr('aria-expanded', 'true');
                }

                // Add role="tooltip" and ID to Bootstrap-generated tooltip
                var tooltipId = $tooltip.attr('id') + '-content';
                var $tooltipElement = $('.tooltip');
                $tooltipElement
                    .attr('role', 'tooltip')
                    .attr('id', tooltipId);

                $tooltipElement.on('mouseleave', function () {
                    $tooltip.tooltip('hide');
                    $tooltip.data('tooltip-visible', false);
                    if (!$tooltip.data('no-aria-expanded')) {
                        $tooltip.attr('aria-expanded', 'false');
                    }
                });
            }
        })
        .on('mouseout', '[data-toggle="tooltip"]', function () {
            var $tooltip = $(this);
            // Delay hiding to allow moving between the trigger and the tooltip
            setTimeout(function () {
                var tooltipHovered = $('.tooltip:hover').length > 0;
                var buttonHovered = $tooltip.data('tooltip-hover');

                if (!buttonHovered && !tooltipHovered) {
                    $tooltip.tooltip('hide');
                    $tooltip.data('tooltip-visible', false);
                    if (!$tooltip.data('no-aria-expanded')) {
                        $tooltip.attr('aria-expanded', 'false');
                    }
                }
            }, 200);
        })
        .on('click', '[data-toggle="tooltip"]', function (e) {
            // Handle keyboard activation (Enter/Space converted to click by screen readers)
            // and mouse clicks
            var $tooltip = $(this);
            var isVisible = $tooltip.data('tooltip-visible');
            var liveRegionId = $tooltip.attr('id') + '-live';

            e.preventDefault();
            e.stopPropagation();

            // Cancel any pending announcement timeout
            var pendingTimeout = $tooltip.data('announcement-timeout');
            if (pendingTimeout) {
                clearTimeout(pendingTimeout);
                $tooltip.data('announcement-timeout', null);
            }

            if (isVisible) {
                $tooltip.tooltip('hide');
                $tooltip.data('tooltip-visible', false);
                if (!$tooltip.data('no-aria-expanded')) {
                    $tooltip.attr('aria-expanded', 'false');
                }

                // Remove live region
                $('#' + liveRegionId).remove();
            } else {
                // Hide other tooltips first
                $('[data-toggle="tooltip"]').not($tooltip).each(function () {
                    $(this).tooltip('hide');
                    $(this).data('tooltip-visible', false);
                    if (!$(this).data('no-aria-expanded')) {
                        $(this).attr('aria-expanded', 'false');
                    }
                    $('#' + $(this).attr('id') + '-live').remove();
                });

                $tooltip.tooltip('show');
                $tooltip.data('tooltip-visible', true);
                if (!$tooltip.data('no-aria-expanded')) {
                    $tooltip.attr('aria-expanded', 'true');
                }

                // Remove any existing live region first
                $('#' + liveRegionId).remove();

                // Wait for Bootstrap to create the tooltip, then announce
                var timeoutId = setTimeout(function () {
                    // Verify tooltip is still visible before announcing
                    if (!$tooltip.data('tooltip-visible')) {
                        return;
                    }

                    var tooltipId = $tooltip.attr('id') + '-content';
                    var $tooltipElement = $('.tooltip').last();

                    // Configure tooltip with proper ARIA attributes
                    $tooltipElement
                        .attr('role', 'tooltip')
                        .attr('id', tooltipId);

                    // Get tooltip content and announce via visually hidden live region
                    var tooltipContent = $tooltipElement.find('.tooltip-inner').text();
                    if (tooltipContent) {
                        // Create fresh live region with content (visually hidden but accessible)
                        var $liveRegion = $('<div>')
                            .attr('id', liveRegionId)
                            .attr('aria-live', 'polite')
                            .attr('aria-atomic', 'true')
                            .css({
                                position: 'absolute',
                                width: '1px',
                                height: '1px',
                                padding: '0',
                                margin: '-1px',
                                overflow: 'hidden',
                                clip: 'rect(0, 0, 0, 0)',
                                whiteSpace: 'nowrap',
                                border: '0'
                            })
                            .text(tooltipContent);
                        $('body').append($liveRegion);
                    }

                    $tooltip.data('announcement-timeout', null);
                }, 150);

                $tooltip.data('announcement-timeout', timeoutId);
            }
        })
        .on('focus', '[data-toggle="tooltip"]', function () {
            var $tooltip = $(this);
            // Ensure aria-expanded reflects current state on focus
            var isVisible = $tooltip.data('tooltip-visible');
            if (!$tooltip.data('no-aria-expanded')) {
                $tooltip.attr('aria-expanded', isVisible ? 'true' : 'false');
            }
        })
        .on('blur', '[data-toggle="tooltip"]', function () {
            var $tooltip = $(this);
            // Close tooltip on blur unless hovering
            setTimeout(function () {
                var tooltipHovered = $('.tooltip:hover').length > 0;
                var buttonHovered = $tooltip.data('tooltip-hover');

                if (!buttonHovered && !tooltipHovered) {
                    $tooltip.tooltip('hide');
                    $tooltip.data('tooltip-visible', false);
                    $tooltip.attr('aria-expanded', 'false');

                    // Remove live region
                    var liveRegionId = $tooltip.attr('id') + '-live';
                    $('#' + liveRegionId).remove();
                }
            }, 100);
        })
        .on('click', function (e) {
            // Close all tooltips when clicking outside
            if (!$(e.target).closest('[data-toggle="tooltip"]').length && !$(e.target).closest('.tooltip').length) {
                $('[data-toggle="tooltip"]').each(function () {
                    $(this).tooltip('hide');
                    $(this).data('tooltip-visible', false);
                    $(this).attr('aria-expanded', 'false');

                    // Remove live region
                    var liveRegionId = $(this).attr('id') + '-live';
                    $('#' + liveRegionId).remove();
                });
            }
        })
        .on('keydown', '[data-toggle="tooltip"]', function (e) {
            // ESC key - hide tooltip
            if (e.keyCode === 27) {
                var $tooltip = $(this);
                $tooltip.tooltip('hide');
                $tooltip.data('tooltip-visible', false);
                $tooltip.attr('aria-expanded', 'false');

                // Remove live region
                var liveRegionId = $tooltip.attr('id') + '-live';
                $('#' + liveRegionId).remove();

                e.preventDefault();
            }
        })

        .on('keydown', function (e) {
            // Global ESC handler
            if (e.keyCode === 27) {
                $('[data-toggle="tooltip"]').each(function () {
                    $(this).tooltip('hide');
                    $(this).data('tooltip-visible', false);
                    if (!$(this).data('no-aria-expanded')) {
                        $(this).attr('aria-expanded', 'false');
                    }
                });
            }
        });
}

module.exports = function () {
    $('body').on('mouseenter focusin', '.info-icon', function () {
        $(this).find('.tooltip').removeClass('d-none');
    });

    $('body').on('mouseleave focusout', '.info-icon', function () {
        $(this).find('.tooltip').addClass('d-none');
    });

    $(document).ready(function () {
        initBootstrapTooltip();
    });
};
